import React from "react";
import { Modal } from "react-bootstrap";
import { bonusPuzzleIds } from "../../../analyticsTags";
import { BonusPuzzleLoginModalType } from "../../../types";

const LoginModal: React.FC<BonusPuzzleLoginModalType> = ({
  isLoggedIn,
  onLogIn,
  onJoin,
  loginStatusChecked,
}) => {
  return (
    <div
      className={`bonus-puzzle-login-modal ${
        isLoggedIn && loginStatusChecked ? "" : " show"
      }`}
    >
      <Modal.Dialog>
        <Modal.Body>
          <div className="login-modal-body">
            <span className="link-top">
              <a
                id={bonusPuzzleIds.bonusPuzzleJoin}
                href={window.location.origin + "/wheel-watchers/register"}
              >
                Wheel Watchers Club SPIN ID
              </a>{" "}
              to play
            </span>
            <div className="or-divider-container">
              <div className="or-divider">
                <span>OR</span>
              </div>
            </div>
            <span className="link-bottom">
              If you are already a member, please{" "}
              <a
                id={bonusPuzzleIds.bonusPuzzleLogin}
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  onLogIn();
                }}
              >
                login
              </a>{" "}
              to play.
            </span>
          </div>
        </Modal.Body>
      </Modal.Dialog>
    </div>
  );
};

export default LoginModal;
